
const util = require('util');

const FormModelBase = require('./base-model');


function EmailbackFormModel () {
	const phoneFormat = {
		validator: function (v) {
			return v.replace(/\D/ig, "").length == 11;
		},
		message: 'введите корректное значение',
	};

	const self = FormModelBase.apply(this, arguments);

	self.Phone.extend({
		required: true,
		validation: phoneFormat,
	});

	return self;
}

util.inherits(EmailbackFormModel, FormModelBase);

module.exports = EmailbackFormModel;

